import { Injectable } from '@angular/core';
import { BehaviorSubject, of, Observable } from 'rxjs';
import { tap, take, map } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { UrlBuilderService } from '@common/services/url-builder.service';
import {
  ExpiryType,
  expiryTypes,
  expiryTypeDays,
  expiryTypeYears, PmaDocumentCentreCategory
} from '@feature/pma-document-centre/pma-document-centre-types';

import * as lodash from 'lodash';

const clone = lodash.cloneDeep;


@Injectable({
  providedIn: 'root'
})
export class PmaDocumentCentreCategoryEditorFacadeService {

  private _categories = new BehaviorSubject<PmaDocumentCentreCategory[]>([]);

  constructor(
    private readonly urlProvider: UrlBuilderService,
    private readonly http: HttpClient
  ) {
  }

  private mapToServerCategory(category: PmaDocumentCentreCategory): any {
    return {
      Key: category.key,
      Name: category.name,
      ExpiryType: category.expiryType ? category.expiryType.label : null,
      DurationMins: category.durationMins
    };
  }

  private mapFromServerCategory(serverCategory: any): PmaDocumentCentreCategory {
    const mapped: PmaDocumentCentreCategory = {
      key: serverCategory.Key,
      durationMins: serverCategory.DurationMins,
      name: serverCategory.Name,
      expiryType: serverCategory.ExpiryType
        ? expiryTypes.find(t => t.label == serverCategory.ExpiryType) as ExpiryType
        : null
  }
    return clone(mapped);
  }

  loadCategories() {
    const url = this.urlProvider.getUrl('document-centre/category/all');
    this.http.get(url).pipe(take(1), tap((results: Array<any>) => {
      console.log('categories (server)', results);
      const mapped = results.map(this.mapFromServerCategory);
      this._categories.next(mapped);
    })).subscribe();
  }

  categories(): Observable<PmaDocumentCentreCategory[]> {
    return this._categories.asObservable();
  }

  deleteCategory(category: PmaDocumentCentreCategory): Observable<boolean> {
    const url = this.urlProvider.getUrl('document-centre/category/delete');
    const mappedCategory = this.mapToServerCategory(category);
    return this.http.post(url, mappedCategory).pipe(take(1), map(() => true), tap(() => this.loadCategories()));
  }

  saveCategory(category: PmaDocumentCentreCategory): Observable<boolean> {
    const url = this.urlProvider.getUrl('document-centre/category');
    const mappedCategory = this.mapToServerCategory(category);
    return this.http.post(url, mappedCategory).pipe(take(1), map(() => true), tap(() => this.loadCategories()));
  }
}
